<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uADwEx/tc-custom/9780814705209.jpg?1719926997588" alt="This image is the cover for the book Political Economy of Hope and Fear"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Political Economy of Hope and Fear
      </h1>
      <p class="bookDescription body article font2">
        <p>Popular liberal writing on race has relied on appeals to the value of "diversity" and the fading memory of the Civil Rights movement to counter the aggressive conservative assault on liberal racial reform generally, and on black well-being, in particular. Yet appeals to fairness and justice, no matter how heartfelt, are bound to fail, Marcellus Andrews argues, since the economic foundations of the Civil Rights movement have been destroyed by the combined forces of globalization, technology, and tight government budgets.<br/><b>The Political Economy of Hope and Fear</b> fills an important intellectual gap in writing on race by developing a hard-nosed economic analysis of the links between competitive capitalism, racial hostility, and persistent racial inequality in post-Civil Rights America. Andrews speaks to the anger and frustration that blacks feel in the face of the nation's abandonment of racial equality as a worthy objective by showing how the considerable difficulties that black Americans face are related to fundamental changes in the economic fortunes of the U.S.<br/><b>The Political Economy of Hope and Fear</b> is an economist's plea for unsentimental thinking on matters of race to replace the mixture of liberal hand wringing and conservative mythmaking that currently passes for serious analysis about the nation's racial predicament.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marcellus William Andrews
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New york University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0cfc3645